var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import { SelectionControl } from '../../core/SelectionControl';
function RadioComponent(props, ref) {
    return React.createElement(SelectionControl, __assign({}, props, { ref: ref, type: "radio" }));
}
/**
 * @tdr
 * TODO: support CSS selectors when crawling client apps
 * @tdr-candidates: input[type="radio"]
 */
export var Radio = forwardRef(RadioComponent);
//# sourceMappingURL=Radio.js.map